import * as Yup from "yup";

export const AddCommentSchema = Yup.object().shape({
    comment: Yup.string().required("Comment is Required"),
});

